// Opaque frames cannot reliably fetch parent-origin assets in WebView2.
// Embed only trusted packaged renderer code under a fresh CSP nonce, never
// document content. The sandbox receives neither native bindings nor tokens.
export async function preparePreview(extension) {
  const pdf = extension === "pdf";
  const base = process.env.BASE_URL || "/";
  const paths = pdf
    ? [base + "file-preview/pdf.html", base + "file-preview/pdf-viewer.js"]
    : [base + "file-preview/office.html", base + "file-preview/viewer.js", base + "file-preview/viewer.css"];
  const texts = await Promise.all(
    paths.map(async (path) => {
      const response = await fetch(path);
      if (!response.ok) throw new Error("预览组件加载失败");
      return response.text();
    }),
  );
  const random = new Uint8Array(16);
  crypto.getRandomValues(random);
  const nonce = Array.from(random, value => value.toString(16).padStart(2, "0")).join("");
  let html = texts[0].replace(
    "script-src 'self' blob:",
    "script-src 'nonce-" + nonce + "' blob:",
  );
  const code = texts[1].replace(/<\/script/gi, "<\\/script");
  html = html.replace(
    '<script src="' + (pdf ? "pdf-viewer.js" : "viewer.js") + '"></script>',
    () => '<script nonce="' + nonce + '">' + code + "</script>",
  );
  if (!pdf)
    html = html.replace(
      '<link rel="stylesheet" href="viewer.css">',
      () =>
        "<style>" + texts[2].replace(/<\/style/gi, "<\\/style") + "</style>",
    );
  return { html, dispose() {} };
}
